import { useNavigate } from 'react-router-dom';
import heartIcon from '../assets/images/heart-icon.png';
import shareIcon from '../assets/images/share-icon.png';
import { getCssBackgroundImage } from '../utils/image';

function PropertyCard({ property }) {
  const {
    title,
    country,
    address,
    price,
    surface,
    beds,
    baths,
    category,
    image,
    favorite,
    paymentPeriod,
    annual
  } = property;

  const navigate = useNavigate();
  const formattedPrice =
    typeof price === 'number' ? price.toLocaleString() : price ?? '';

  const handleOpenDetails = () => navigate(`/properties/${property.id}`);

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      handleOpenDetails();
    }
  };

  return (
    <article className="property-card">
      <div
        className="property-media"
        role="button"
        tabIndex={0}
        onClick={handleOpenDetails}
        onKeyDown={handleKeyDown}
        style={{ backgroundImage: getCssBackgroundImage(image) }}
      >
        <div className="property-overlay" />

        {/* HEADER TEXT + ACTION ICONS */}
        <div className="property-header">
          <div>
            <p className="property-title">
              {title} <span>{country}</span>
            </p>
            <p className="property-address">{address}</p>
          </div>

          <div className="property-icons">
           {/*  <button className={`favorite-toggle ${favorite ? "active" : ""}`}>
              <img src={heartIcon} alt="favorite" />
            </button>
            <button className="share-button">
              <img src={shareIcon} alt="share" />
            </button> */}
          </div>
        </div>

        {/* GLASS PRICE PANEL */}
        <div className="property-price-box">
          {/* TOP ROW */}
          <div className="price-top-row">
            <p className="pp-price">{formattedPrice}</p>

           
            <p className="pp-category">{category}</p>
          </div>

          {/* BOTTOM ROW */}
          <div className="price-bottom-row">
            <div>
              
              <div className="pp-value">{surface}</div>
              <div className="pp-value">{beds} bds · {baths} ba</div>
            </div>

            <div>
              <div className="pp-title">Payment Period</div>
              <div className="pp-value">{paymentPeriod} years</div>
            </div>

            <div>
              <div className="pp-title">Annual stay</div>
              <div className="pp-value">{annual} days</div>
            </div>
          </div>
        </div>
      </div>
    </article>
  );
}

export default PropertyCard;
